angular.module('bbl.directives', [
	'bbl.directives.slide-toggle',
	'bbl.directives.phone-input',
	'bbl.directives.sortable-col',
	'bbl.directives.connected-lines',
	'bbl.directives.pagination',
	'bbl.directives.ng-clip',
	'bbl.directives.ng-modal',
  'bbl.directives.ng-autofocus',
  'bbl.directives.ng-return',
  'bbl.directives.dd-fixed',
  'bbl.directives.greeting-cta',
  'bbl.directives.file-model',
]);

require('./slide-toggle');
require('./phone-input');
require('./sortable-col');
require('./connected-lines');
require('./ng-clip');
require('./pagination');
require('./ng-modal');
require('./ng-autofocus');
require('./ng-return');
require('./dd-fixed');
require('./dialpad-widget');
require('./talk-widget');
require('./lang-selector');
require('./greeting-cta');
require('./file-model');

require('./play-btn/play-btn.controller.js');
require('./rating-widget/rating-widget.controller.js');



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/directives/index.js
 ** module id = 162
 ** module chunks = 0
 **/